export default __webpack_public_path__ + "static/media/Male-1.d9bf20f3.svg";